
import { AlertItem } from "./AlertItem";
import { EmptyState } from "./EmptyState";
import { AlertsListContainerProps } from "./types";

export function AlertsListContainer({ 
  isAuthenticated, 
  userAlerts, 
  isLoading, 
  currentGoldPrice, 
  currentSilverPrice,
  onToggle,
  onDelete
}: AlertsListContainerProps) {
  if (!isAuthenticated || userAlerts.length === 0) {
    return <EmptyState isAuthenticated={isAuthenticated} />;
  }

  return (
    <div className="space-y-4">
      {userAlerts.map((alert) => (
        <AlertItem 
          key={alert.id}
          alert={alert}
          onToggle={onToggle}
          isLoading={isLoading}
          currentGoldPrice={currentGoldPrice}
          currentSilverPrice={currentSilverPrice}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
